import { OutDesignAST, OutDesignNode } from "../ast"
import { OutDesignOperation } from "./operators"

export function walkSync(node: OutDesignNode, action: OutDesignOperation): OutDesignNode | OutDesignNode[] {

  const res = action(node) ?? node

  if (Array.isArray(res)) {
    return res.map(n => walkNode(n, action)).flat()
  }

  return walkNode(res, action)
}

function walkNode(
  node: OutDesignNode,
  action: OutDesignOperation): OutDesignNode {

  if (!node.children) return node

  // Specific walk for LineBlocks, BulletList and OrderedList...
  const is2D =
    node.type === "LineBlock" ||
    node.type === "BulletList" ||
    node.type === "OrderedList"

  if (is2D) {
    return {
      ...node,
      children: (node.children as OutDesignNode[][]).map(line =>
        line.flatMap(child => {
          const result = walkSync(child, action)
          return [result]
        })
      )
    }
  }

  // And now for DefinitionLists...
  if (node.type === "DefinitionList") {
    return {
      ...node,
      children: (node.children as any[]).map(([term, defs]) => [
        // term: Inline[]
        term.flatMap((child: OutDesignNode) => {
          const result = walkSync(child, action)
          return Array.isArray(result) ? result : [result]
        }),

        // defs: Block[][]
        defs.map((def: OutDesignNode[]) =>
          def.flatMap(child => {
            const result = walkSync(child, action)
            return Array.isArray(result) ? result : [result]
          })
        )
      ])
    }
  }

  const newChildren: OutDesignNode[] = []

  for (const child of node.children) {

    const result = walkSync(child, action)

    if (Array.isArray(result)) {
      newChildren.push(...result)
    } else {
      newChildren.push(result)
    }
  }

  return {
    ...node,
    children: newChildren
  }
}


export function walkAST(
  ast: OutDesignAST,
  action: (node: OutDesignNode) => OutDesignNode | OutDesignNode[] | undefined
): OutDesignAST {

  return {
    ...ast,
    blocks: ast.blocks
      .map(block => walkSync(block, action))
      .flat()
      // maybe the flattening should be done elsewhere...?
  }
}
